import { render } from "./batchMa.vue?vue&type=template&id=14ac0608&scoped=true"
import script from "./batchMa.vue?vue&type=script&lang=js"
export * from "./batchMa.vue?vue&type=script&lang=js"

import "./batchMa.vue?vue&type=style&index=0&id=14ac0608&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ac0608"]])

export default __exports__